<template>
    <a-modal
        title="简历拜访"
        :visible="visible"
        class="modal-initialize"
        width="588px"
        @cancel="cancelFun"
        @ok="okFun"
    >
        <div class="bomb-remind">
            <div class="bomb-form">
                <a-form class="inline-form" :form="form">
                    <a-form-item
                        label="拜访状态"
                        v-bind="formItemLayout"
                        required
                        labelAlign="left"
                    >
                        <a-select
                            style="width: 100%;"
                            v-decorator="['vistatus',{rules: [{ required: true, message: '请选择拜访状态' }]} ]"
                            placeholder="拜访状态"
                        >
                            <a-select-option v-for="(item, key) in config.vistatus" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item
                        label="拜访内容"
                        v-bind="formItemLayout"
                        required
                        labelAlign="left"
                    >
                        <a-textarea
                            v-decorator="['remark',{rules: [{ required: true, message: '请输入拜访内容' }]} ]"
                            placeholder="拜访内容"
                            :auto-size="{ minRows: 3 }"
                        />
                    </a-form-item>

                    <a-form-item
                        label="标签"
                        v-bind="formItemLayout"
                        labelAlign="left"
                    >
                        <a-select
                            v-decorator="['flag',{rules: [{ required: false, message: '请选择或输入标签' }]} ]"
                            mode="tags"
                            style="width: 100%"
                            placeholder="请选择或输入标签"
                        >
                            <a-select-option v-for="(item, key) in config.flag" :key="key" :value="'f,' + item.fid">{{
                                    item.fname
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </a-form>
            </div>
        </div>
    </a-modal>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        rid: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            form: this.$form.createForm(this),
            formItemLayout: {
                labelCol: {
                    span: 6
                },
                wrapperCol: {
                    span: 18
                },
            },
            config: {},
            flag: [],
            dateFormat: 'YYYY-MM',
        };
    },
    watch: {
        // 实现双向绑定
        visible(val) {
            if (val === false) {
                this.form.resetFields(); // 重置表单
            } else {
                this.getData();
            }
        },
    },
    model: {
        prop: 'visible',
        // 这个事件名可以随意写，它实际上是规定了子组件要更新父组件值需要注册的方法
        event: 'changeVisible'
    },
    methods: {
        closeModal() {
            this.$emit('changeVisible', false);
        },
        getData() {
            let data = {};
            data.rid = this.rid;

            this.http('/manage/revisit/info', data, (res) => {

                this.config = res.config;

                if (res.flag) {
                    this.$nextTick(() => {
                        this.form.setFieldsValue({
                            flag: res.flag,
                        });
                    });
                }

            }, null, 1);
        },
        okFun() {
            this.form.validateFields(
                (errors, values) => {
                    if (!errors) {

                        // console.log(values);return;

                        let url = '/manage/revisit/save';
                        values.rid = this.rid;

                        this.http(url, values, (res) => {
                            this.toast({content: '操作成功'});
                            this.closeModal();
                            this.$emit("confirm");
                        }, null, 1);
                    }
                }
            );
        },
        cancelFun() {
            this.closeModal();
        },
    }
}
</script>